/**
 * use-column-sizing.ts
 *
 * Larghezze delle colonne delle tabelle TanStack, ridimensionabili dall'utente e
 * persistite in localStorage (una chiave per tabella).
 */

import { useLocalStorage } from '@mantine/hooks';
import type { ColumnSizingState, Updater } from '@tanstack/react-table';

/** Opzioni da spalmare in useReactTable per abilitare il resize delle colonne. */
export const RESIZABLE_TABLE_OPTIONS = {
  enableColumnResizing: true,
  columnResizeMode: 'onChange' as const,
  defaultColumn: { size: 150, minSize: 60, maxSize: 800 },
};

export function useColumnSizing(tableId: string) {
  const [columnSizing, setColumnSizing] = useLocalStorage<ColumnSizingState>({
    key: `ufficio-stile-table-sizing-${tableId}`,
    defaultValue: {},
    getInitialValueInEffect: false,
  });

  const onColumnSizingChange = (updater: Updater<ColumnSizingState>) =>
    setColumnSizing((old) => (typeof updater === 'function' ? updater(old) : updater));

  return { columnSizing, onColumnSizingChange };
}
